<div class="panel">
  <mat-button-toggle-group
    class="sub-tab-toggle"
    [value]="activeSubTab"
    (change)="onSubTabChanged($event.value)"
    aria-label="File specifications sub-tab"
  >
    <mat-button-toggle value="stills">
      <mat-icon>image</mat-icon>
      Stills
      <span class="sub-tab-count">· {{ stillsSpecs.length }}</span>
    </mat-button-toggle>
    <mat-button-toggle value="videos">
      <mat-icon>movie</mat-icon>
      Videos
      <span class="sub-tab-count">· {{ videosSpecs.length }}</span>
    </mat-button-toggle>
  </mat-button-toggle-group>

  @if (activeSubTab === 'stills') {
    <app-still-format-config-view
      [stillsSpecs]="stillsSpecs"
      [loaded]="loaded"
      [canWrite]="canWrite"
      [canAudit]="canAudit"
      (createStills)="onCreateStills()"
      (updateStills)="onUpdateFileSpecification($event)"
      (deleteStills)="onDeleteFileSpecification($event)"
      (viewStillsHistory)="onViewFileSpecificationHistory($event)"
    ></app-still-format-config-view>
  } @else {
    <app-video-format-config-view
      [videosSpecs]="videosSpecs"
      [loaded]="loaded"
      [canWrite]="canWrite"
      [canAudit]="canAudit"
      (createVideos)="onCreateVideos()"
      (updateVideos)="onUpdateFileSpecification($event)"
      (deleteVideos)="onDeleteFileSpecification($event)"
      (viewVideosHistory)="onViewFileSpecificationHistory($event)"
    ></app-video-format-config-view>
  }
</div>
